import { render, staticRenderFns } from "./ClosedDays.vue?vue&type=template&id=f0e4bf32&scoped=true&"
import script from "./ClosedDays.vue?vue&type=script&lang=js&"
export * from "./ClosedDays.vue?vue&type=script&lang=js&"
import style0 from "./ClosedDays.vue?vue&type=style&index=0&id=f0e4bf32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e4bf32",
  null
  
)

export default component.exports